export default {
  title: {
    management: 'Satisfaction Survey Management',
    invitation: 'Satisfaction Survey Invitation',
    question: {
      add: 'Add New Question',
      edit: 'Edit Question'
    },
    step: {
      add: 'Add New Step',
      edit: 'Edit Step'
    },
    questionnaire: {
      add: 'Add New Questionnaire',
      edit: 'Edit Questionnaire'
    },
    microSite: {
      add: 'Add New Satisfaction',
      edit: 'Edit Satisfaction'
    },
    emailTemplate: {
      add: 'Add New Email Template',
      edit: 'Edit Email Template'
    },
    iconSelector: 'Select Icon',
    questionSelector: 'Select Question',
    stepSelector: 'Select Step'
  },
  menu: {
    management: 'Satisfaction Survey Management',
    invitation: 'Satisfaction Survey Invitation'
  },
  tabMenu: {
    microSite: 'Microsite',
    questionnaire: 'Survey Template',
    step: 'Step',
    question: 'Question',
    emailTemplate: 'Email Template'
  },
  questionType: {
    text: 'Text',
    date: 'Date',
    single: 'Single Selector',
    multiple: 'Multiple Selector',
    attachment: 'Attachment',
    link: 'Agreement Link',
    location: 'Location',
    country: 'Country/Region',
    province: 'Province',
    city: 'City',
    nationality: 'Nationality',
    language: 'Language',
    nps: 'NPS',
    stars: 'Stars Rating Question'
  },
  questionnaireType: {
    candidateApply: 'Candidate Application Satisfaction Survey',
    candidateInterview: 'Candidate Interview Satisfaction Survey',
    hmScore: 'Hiring Management Rating Satisfaction Survey',
    hmInterview: 'Hiring Management Interview Satisfaction Survey',
    general: 'Manually Triggered Survey'
  },
  emailTemplateType: {
    candidateSurvey: 'AUTOMATED SURVEY - Candidate Post Interview Survey',
    HMSurvey: 'AUTOMATED SURVEY - Hiring Management Post Rating survey',
    HMInterviewSurvey: 'AUTOMATED SURVEY - Hiring Management Post Interview survey',
    defaultSurvey: 'MANUAL SURVEY'
  },
  language: {
    cn: 'Simplified Chinese',
    tc: 'Traditional Chinese',
    en: 'English'
  },
  label: {
    question: 'Question',
    questionName: 'Question Name',
    questionType: 'Question Type',
    questionStatus: 'Question Status',
    questionOption: 'Question Option',
    optionNo: 'Option {number}',
    step: 'Step',
    stepName: 'Step Name',
    stepIcon: 'Step Icon',
    stepStatus: 'Step Status',
    isRequiredQuestion: 'Required Question',
    questionnaireName: 'Questionnaire Name',
    questionnaireStatus: 'Questionnaire Status',
    questionnaireType: 'Questionnaire Type',
    micrositeName: 'Microsite Name',
    micrositeTitle: 'Title',
    micrositeUrl: 'Preview Link',
    micrositeIsFinished: 'Finish Design',
    micrositeStatus: 'Status',
    emailSubject: 'Email Subject',
    emailType: 'Email Type',
    microsite: 'Microsite',
    invitationDate: 'Invitation Date',
    satisfactionSurveyDate: 'Complete Date',
    export: 'Export',
    recruiter: 'Recruiter',
    operation: 'Action',
    questionnaire: 'Questionnaire',
    candidate: 'Candidate',
    company: 'Company',
    job: 'Job',
    status: 'Status',
    finished: 'Finished',
    unfinished: 'Unfinished',
    keywordsSearch: ' Keywords search',
    noticeSuccessMessage: 'The candidate has been successfully reminded',
    operationBtn: {
      notice: 'Remind',
      cancel: 'Cancel',
      view: 'View'
    },
    statusList: {
      all: 'All Status',
      invited: 'Invited',
      finished: 'Finished',
      cancelled: 'Cancelled'
    },
    title: {
      cn: '@:admin.company.satisfactionSurvey.language.cn标题',
      tc: '@:admin.company.satisfactionSurvey.language.tc标题',
      en: '@:admin.company.satisfactionSurvey.language.en标题'
    },
    name: {
      cn: '@:admin.company.satisfactionSurvey.language.cn Name',
      tc: '@:admin.company.satisfactionSurvey.language.tc Name',
      en: '@:admin.company.satisfactionSurvey.language.en Name',
      country: {
        cn: 'Country/Region @:admin.company.satisfactionSurvey.language.cn Name',
        tc: 'Country/Region @:admin.company.satisfactionSurvey.language.tc Name',
        en: 'Country/Region @:admin.company.satisfactionSurvey.language.en Name'
      },
      province: {
        cn: 'Province @:admin.company.satisfactionSurvey.language.cn Name',
        tc: 'Province @:admin.company.satisfactionSurvey.language.tc Name',
        en: 'Province @:admin.company.satisfactionSurvey.language.en Name'
      },
      city: {
        cn: 'City @:admin.company.satisfactionSurvey.language.cn Name',
        tc: 'City @:admin.company.satisfactionSurvey.language.tc Name',
        en: 'City @:admin.company.satisfactionSurvey.language.en Name'
      }
    },
    placeholder: {
      cn: '@:admin.company.satisfactionSurvey.language.cn Placeholder',
      tc: '@:admin.company.satisfactionSurvey.language.tc Placeholder',
      en: '@:admin.company.satisfactionSurvey.language.en Placeholder',
      country: {
        cn: 'Country/Region @:admin.company.satisfactionSurvey.language.cn Placeholder',
        tc: 'Country/Region @:admin.company.satisfactionSurvey.language.tc Placeholder',
        en: 'Country/Region @:admin.company.satisfactionSurvey.language.en Placeholder'
      },
      province: {
        cn: 'Province @:admin.company.satisfactionSurvey.language.cn Placeholder',
        tc: 'Province @:admin.company.satisfactionSurvey.language.tc Placeholder',
        en: 'Province @:admin.company.satisfactionSurvey.language.en Placeholder'
      },
      city: {
        cn: 'City @:admin.company.satisfactionSurvey.language.cn Placeholder',
        tc: 'City @:admin.company.satisfactionSurvey.language.tc Placeholder',
        en: 'City @:admin.company.satisfactionSurvey.language.en Placeholder'
      }
    },
    agreementLink: {
      cn: '@:admin.company.satisfactionSurvey.language.cn Agreement Link',
      tc: '@:admin.company.satisfactionSurvey.language.tc Agreement Link',
      en: '@:admin.company.satisfactionSurvey.language.en Agreement Link'
    }
  },
  placeholder: {
    searchKeyword: {
      question: 'Please enter question name',
      step: 'Please enter step name'
    },
    questionnaireName: 'Please enter questionnaire name',
    step: 'Please select step',
    stepName: 'Please enter step name',
    question: 'Please select Question',
    questionName: 'Please enter question name',
    questionType: 'Please select question type',
    agreementLink: 'Please enter agreement link',
    placeholder: 'Please enter question placeholder',
    optionName: 'Please enter option name',
    questionnaireType: 'Please select questionnaire type',
    emailSubject: 'Please enter email subject',
    emailTemplate: 'Please enter email template',
    micrositeName: 'Please enter micro site name',
    selectMicrositeName: 'Please select micro site'
  },
  message: {
    questionNameRequired: 'Please enter question name',
    questionTypeRequired: 'Please select question type',
    agreementLinkRequired: 'Please enter agreement link',
    optionNameRequired: 'Please enter option name',
    stepNameRequired: 'Please enter step name',
    stepQuestionsRequired: 'Please select Question',
    NPSQuestionSingle: 'Only one NPS question per question',
    stepIconRequired: 'Please select step icon',
    questionnaireStepsRequired: 'Please select step',
    questionnaireMicroSiteRequired: 'Please select microsite',
    NPSStepSingle: 'Only one NPS question per question',
    questionnaireNameRequired: 'Please enter questionnaire name',
    questionnaireTypeRequired: 'Please select questionnaire type',
    emailSubjectRequired: 'Please enter email subject',
    emailTemplateRequired: 'Please enter email template',
    emailTemplateTip: {
      warn: `
        Please do not <span class="strong">remove</span> the inner shape of the edit box below, such as <span class="strong">{{first_ Placeholder for name}}</span>. 
        <br/>
        You can edit the style of the placeholder to adjust the style of the system's default copy, such as font, font size, and so on.
      `,
      description: `
        <tr>
          <th>Placeholder</th>
          <th>Value / Description</th>
        </tr>
        <tr>
          <td>{{questionnaire_page_link}}</td>
          <td>Page link selected at invitation</td>
        </tr>
        <tr>
          <td>{{first_name}}</td>
          <td>First name of invited candidate</td>
        </tr>
        <tr>
          <td>{{last_name}}</td>
          <td>Last name of invited candidate</td>
        </tr>
        <tr>
          <td>{{hr_first_name}}</td>
          <td>First name of HR</td>
        </tr>
        <tr>
          <td>{{hr_last_name}}</td>
          <td>Last name of HR</td>
        </tr>
        <tr>
          <td>{{candidate_profile_link}}</td>
          <td>Page link of candidate profile</td>
        </tr>
        <tr>
          <td>{{questionnaire_page_qrcode}}</td>
          <td>Event QR code</td>
        </tr>
      `
    },
    testEmailHasSent: 'Test email send success!'
  },
  btn: {
    saveAndDesign: 'Save And Go Design',
    goDesign: 'Go Design',
    sendTestEmail: 'Send Test Email'
  },
  microsite: {
    micrositeName: 'Microsite Name',
    micrositeLink: 'Microsite Link',
    webEnLink: 'Web (English)',
    webCnLink: 'Web (Chinese)',
    webTcLink: 'Web (Traditional Chinese)',
    mobileEnLink: 'Mobile (English)',
    mobileCnLink: 'Mobile (Chinese)',
    mobileTcLink: 'Mobile (Traditional Chinese)'
  },
  headerImage: {
    tipMessage: {
      pc: 'Recommended Size is: 1920*750 ( < 5MB )',
      mobile: 'Recommended Size is: 750*450 ( < 5MB )'
    }
  }
}
